import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { Nav } from "../components/Nav";
import { Footer } from "../components/Footer";
import { ReceiptCard } from "../components/ReceiptCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReceiptPublic() {
  const { hash } = useParams();
  const [receipt, setReceipt] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/r/${encodeURIComponent(hash)}`)
      .then((r) => setReceipt(r.data))
      .catch((e) => setError(e?.response?.data?.detail || "receipt_not_found"));
  }, [hash]);

  return (
    <div className="min-h-screen bg-[#020B14] text-white" id="top">
      <Nav />
      <main className="pt-24 pb-24">
        <div className="max-w-[920px] mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-3 mono text-[11px] uppercase tracking-[0.2em] text-slate-500 mb-8">
            <Link to="/" data-testid="crumb-home" className="hover:text-white">Platform</Link>
            <span>/</span>
            <span className="text-slate-200">Public receipt</span>
          </div>

          <header className="max-w-2xl mb-10">
            <div className="mono text-[10px] uppercase tracking-[0.3em] text-[#EAB308]">
              Public-safe KATLAS receipt
            </div>
            <h1
              data-testid="public-receipt-headline"
              className="font-display text-3xl sm:text-4xl mt-4 leading-[1.1]"
            >
              Verifiable proof.
              <br />
              <span className="text-slate-400">
                No private data exposed.
              </span>
            </h1>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed">
              This view shows only public-safe fields. The signed envelope,
              API credentials, raw private data and withheld assets remain on
              the backend.
            </p>
          </header>

          {error && (
            <div
              data-testid="public-receipt-error"
              className="border border-white/10 bg-white/[0.02] p-8 mono text-xs"
            >
              <div className="uppercase tracking-[0.2em] text-slate-400">
                {typeof error === "string" ? error : error?.error || "receipt_not_found"}
              </div>
              <p className="mt-3 font-sans text-sm text-slate-300">
                No receipt matches this reference. The hash may be incorrect or
                the receipt may not have been emitted.
              </p>
            </div>
          )}

          {!receipt && !error && (
            <div className="mono text-xs uppercase tracking-[0.2em] text-slate-500">
              Loading receipt…
            </div>
          )}

          {receipt && (
            <>
              <ReceiptCard receipt={receipt} />

              <div className="mt-8 grid sm:grid-cols-2 gap-px bg-white/[0.06] border border-white/[0.06]">
                <div className="bg-[#020B14] p-5">
                  <div className="mono text-[10px] uppercase tracking-[0.2em] text-[#0066FF]">
                    What this view exposes
                  </div>
                  <ul className="mt-3 text-xs text-slate-300 space-y-1.5">
                    <li>· receipt hash</li>
                    <li>· attestation reference</li>
                    <li>· signer reference and fingerprint</li>
                    <li>· node timestamp</li>
                    <li>· verification status</li>
                    <li>· shared evidence refs</li>
                    <li>· withheld evidence count</li>
                  </ul>
                </div>
                <div className="bg-[#020B14] p-5">
                  <div className="mono text-[10px] uppercase tracking-[0.2em] text-[#EAB308]">
                    What this view never exposes
                  </div>
                  <ul className="mt-3 text-xs text-slate-300 space-y-1.5">
                    <li>· API key or authorisation header</li>
                    <li>· certificate text or certificate encoding</li>
                    <li>· the full signed envelope</li>
                    <li>· raw personal data</li>
                    <li>· private payloads</li>
                    <li>· withheld assets</li>
                  </ul>
                </div>
              </div>
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
